import React from 'react'
import mac from "./img/bgone.png"
import web from "./img/MyCircleweb.svg"
import Image from "../../../../Components/Image"

function MyCircles() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">MyCircles</div>
                <div className="work_type">Mobile Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        The next generation of social media...
                        Connect with your circle of friends and family. <br/>MyCircle creates a unique opportunity for easy communication of the most important things.
                    </p>
                    <p>
                        MyCircles allow you to send concise voice notes to all your loved ones quickly and easily.
                    </p>
                    <a href='https://apps.apple.com/gb/app/mycircles/id1599467961' className="work_btn" target='_blank'>Get on the app store</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href='https://mycircle.global/'className="work_btn"  target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="images">
                <Image src={mac} />
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">
                    
                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> Mobile : React-native, Expo, SASS, HookState.<br/> Website : React, SASS</div>
                    </p>
                    <p>
                        <div className="dev_title">Back End</div>
                        <div className="dev_info">NodeJs, Express, Firebase, Cloud functions</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default MyCircles